import { render } from "./SquatLockerPrivacyPolicy.vue?vue&type=template&id=cbc2ef92&scoped=true"
import script from "./SquatLockerPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./SquatLockerPrivacyPolicy.vue?vue&type=script&lang=js"

import "./SquatLockerPrivacyPolicy.vue?vue&type=style&index=0&id=cbc2ef92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbc2ef92"]])

export default __exports__